// Copyright (c) 2016 Deere & Company

import './index.scss';
import OpenPips from './open-pips';
import actionCreators from '../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    busyCounter: state.pips.openPips.busyCounter
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(OpenPips);



// WEBPACK FOOTER //
// ./src/pip/open-pips/components/index.js